import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
//import Donate from './Donate';
import DateTime from './DateTime';

class Header extends Component {
  loginOptions() {
    return (
      <div className="dropdown-button">
        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Login Here!
        </button>
        <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
          <a className="dropdown-item" style={{ color: "red" }} href="/auth/google">Login With Google</a>
        </div>
      </div>
    );
  }

  renderContent() {
    return null; // Temporarily hide Donate and Logout options.
  }

  render() {
    return (
      <nav className="nav-extended">
        <div className="nav-wrapper nav-wrapper-custom">
          <Link to='/' className="left brand-logo">UNIGRAM 95 Alumnis</Link>
          {/* Mobile menu trigger can be implemented here if needed */}
          <ul className="right">
            {this.renderContent()}
          </ul>
        </div>
        <div className="nav-content-center">
          <div className="dateTime"><DateTime /></div>
          <ul className="tabs tabs-transparent">
            <li><NavLink to='/about' activeClassName="active">About</NavLink></li>
            <li><NavLink to='/alumnis' activeClassName="active">Meet The Team</NavLink></li>
            <li><NavLink to='/events' activeClassName="active">Events</NavLink></li>
            <li><NavLink to='/projects' activeClassName="active">Projects</NavLink></li>
          </ul>
        </div>
      </nav>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Header);